import { Layout } from '@smart-kasa/ui';
import { Outlet } from 'react-router-dom';

export const AppLayout = () => (
  <Layout>
    <Outlet />
  </Layout>
);
